import './FundPage.scss'

import Fund1 from '../../assets/images/fund-page/fund-1.png';
import Fund2 from '../../assets/images/fund-page/fund-2.png';
import Fund3 from '../../assets/images/fund-page/fund-3.png';
import Fund4 from '../../assets/images/fund-page/fund-4.png';
import ApplyBanner from '../../assets/images/fund-page/banner-apply.png';
import CriteriaBanner from '../../assets/images/fund-page/banner-criteria.png';

const APPLY_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSdr8QkjwqB5ok5K1ubaIL7fGeeTuEXSQOCaUEGd9Zx2d9ORHg/viewform"

export const FundPage = () => {
    const handleClickApplyNow = () => {
        window.open(APPLY_FORM_URL, '_blank');
    }

    return <div id='fund-page'>
        <section className="title-section">
            <div className='text-block'>
                <h1 className='mobile-center sub-title'>Open Campus</h1>
                <h1 className='mobile-center'>$10M Global Educators Fund</h1>
                <h2 className='sub-title mobile-center'>Earn $EDU for developing educational content</h2>
                <div className='button-default' onClick={handleClickApplyNow}>Apply Now</div>
            </div>
            <div>
                <img className='fund-img-1' src={Fund1} />
            </div>
        </section>

        <section className='decentralized-section'>
            <div>
                <img className='fund-img-2' src={Fund2} />
            </div>
            <div className='text-block'>
                <h2>Open Campus Supports Decentralized Education</h2>
                <div>
                    <p>
                        Open Campus is administering a $10M grant fund powered by our native token, $EDU.
                    </p>
                    <p>
                        The purpose is to inspire and support teachers and creators in developing educational content for a decentralized education system. The Fund serves as a motivational tool for teachers, fostering the creation of high-quality educational materials.
                    </p>
                    <p>
                        The Fund also enables educators to possess and experience digital property rights, guaranteeing all educators have ownership of their digital intellectual property and receive their rightful portion of the revenue generated from their grant-funded content.
                    </p>
                </div>
            </div>
        </section>

        <section className="funding-section">
            <div className='text-block'>
                <h2 className='sub-title'>Funding of up to $100k</h2>
                <div>
                    <p>
                        Applications may be submitted for up to $100k in grant funding. Accepted applicant’s issued grant will be distributed in our native token, $EDU* as a self-sustaining bid for the decentralized education ecosystem.
                    </p>
                    <p>
                        Upon acceptance of your application, you will receive a partial disbursement of the grant fund to assist you in creating the proposed content. When the content is completed, you will receive a second installment which can be used to market your content to a broader audience.
                    </p>
                    <p>
                        Content will be listed on Open Campus launch partners (e.g. TinyTap) for use by its subscribers, and revenue generated from these courses will be distributed to creators. We believe that this approach ensures a fair distribution of revenue among all educators and creators, in a way that is transparent and accessible.
                    </p>
                </div>
                <br />
                <div className='button-default' onClick={handleClickApplyNow}>Apply Now</div>
                <br />
                <div className='remarks'>
                    *EDU - EDU is the native token of the Open Campus Protocol. Grants may be disbursed in $EDU which can be traded for fiat or other cryptocurrencies. The payment option will be decided by the foundation administrators.
                </div>
                <div className='remarks'>
                    EDU token holders can participate in Open Campus DAO governance by submitting and voting on proposals to guide the development of Open Campus Protocol.
                </div>
                <br />
            </div>
            <div>
                <img className='fund-img-3' src={Fund3} />
            </div>
        </section>

        <div className='gradient-overlay banner-parent'>
            <img src={CriteriaBanner} className='banner' />
            <section className='column'>
                <div className='center-text mobile-left'>The Global Educators Fund invites educators to design their content for</div>
                <div className='center-text mobile-left'><strong>students Pre-K to 12th grade.</strong></div>

                <section className='criteria-section'>
                    <div>
                        <div><strong>Content Medium</strong></div>
                        <div>Creators can design their educational content as</div>
                        <div>
                            <ul>
                                <li>Videos</li>
                                <li>Interactive games </li>
                                <li>Worksheets</li>
                            </ul>
                        </div>

                        <div><strong>Subject</strong></div>
                        <div>The first phase focuses* on education areas that are typically underserved today.</div>
                        <br className='desktop-only' />
                        <div>
                            <ul>
                                <li>Diversity and Inclusion</li>
                                <li>Emotional Intelligence</li>
                                <li>Life Skills</li>
                                <li>Financial Literacy</li>
                                <li>Climate Change and Sustainability</li>
                            </ul>
                        </div>
                        <div className='remarks'>*Note: If you are an expert in any other subject areas, please still submit your application as we welcome any new initiatives or ideas.</div>
                    </div>

                    <div>
                        <div><strong>Language</strong></div>
                        <p>At this time, Open Campus only supports applications submitted in English but educators may create content in their native languages.</p>
                        <div><strong>Content Guidelines</strong></div>
                        <div>The content must be created by a Qualified Educator or Educators, Education Organization, or someone with subject matter knowledge in the educational content.</div>
                        <br />
                        <div>
                            <ul>
                                <li>Educational content should cover basic knowledge of selected subject areas.</li>
                                <li>Educational content must target learning goals for the intended audience.</li>
                                <li>Educational content must be compatible with Open Campus partners’ platforms.</li>
                            </ul>
                        </div>
                    </div>
                </section>

                <div className='box banner-parent'>
                    <img src={ApplyBanner} className='banner' />
                    <div className='center-text'>
                        Interested educators and creators need to fill in the attached <strong>form</strong>.
                        <br />
                        The form details the information required in order to apply for the fund. Applicants should submit a proposal that includes the following information:
                    </div><br />

                    <div>
                        <ul>
                            <li>
                                Name and Email*<br />
                                <div className='italic'>
                                    *Your Email will not be shared beyond the <strong>Global Educators Fund Committee</strong>
                                </div>
                            </li>
                            <li>A title for the content, a brief description, and an objective, including the subject area and target age range.</li>
                            <li>Content outline, including the basic knowledge covered.</li>
                            <li>Applicants can choose to create Videos, Interactive Games, Worksheets, in any language.</li>
                        </ul>
                    </div>
                    <div className='button-default' onClick={handleClickApplyNow}>Apply Now</div>
                </div>

                <h2 className='center-text'>Want to get updates?</h2>
                <p className='center-text'>
                    To stay updated, please visit <strong>opencampus.xyz</strong> for more information about
                    {' '}<br className='desktop-only' />
                    our mission to empower educators worldwide. Follow us on <strong>X (Twitter)</strong>
                    {' '}<br className='desktop-only' />
                    and join our <strong>Discord</strong> to participate in our growing community.
                </p>
                <div className='center-text'>
                    For specific questions on Open Campus Global Educators Fund, please
                    {' '}<br className='desktop-only' />
                    email educatorsfund@opencampus.xyz.
                </div>
            </section>
        </div>

        <section className='global-educators-section'>
            <div className='text-block'>
                <h2 className='sub-title'>Global Educators Fund Committee</h2>
                <p>Open Campus and its partners are dedicated to providing transparency to our Global Educators Fund. Alongside TinyTap, we have established a pedagogy committee to determine if applications received for the GEF are of quality and fit the criteria outlined in the application and on our website.</p>
                <p>We will not review applications based on the quality or qualifications of the applicant but rather the proposed content subject matter, medium, and intended audience.</p>
                <div>Any use of the following will automatically disqualify any applicant:</div>
                <div>
                    <ul>
                        <li>Violence or the incitement thereof<br />
                            *Your Email will not be shared beyond the Global Educators Fund Committee</li>
                        <li>Themes surrounding narcotics, weapons, hate speech, and other related topics</li>
                        <li>Language or attitudes that may be discriminatory or harassing in nature</li>
                        <li>Usage of plagiarized contents or copyrighted contents that infringe upon the rights of the original owner(s)</li>
                        <li>Any other topics that may involve illegal, obscene, or malicious actions or content</li>
                    </ul>
                </div>
                <p>The committee members will not be revealed to protect them from potential malicious behavior. </p>
                <div>Thank you for understanding,<br />
                    The Global Educators Fund Committee</div>
            </div>

            <div>
                <img src={Fund4} className='fund-img-4' />
            </div>
        </section>
    </div>
}